import { gsap } from "gsap";
import { Global } from "./../global";

export const menu = {
  trigger: document.querySelector(".trigger a"),
  active: "is-active",
  isOpen: false,
  isTransition: false,
  init: () => {
    menu.click();
  },
  click: () => {
    Global.menuItem.forEach(function(item){
      item.addEventListener('click', function(){
        if(this.className != menu.active){
          Global.menuItem.forEach(function(tgt){
            tgt.classList.remove(menu.active)
          })
          this.classList.add(menu.active)
        }
        menu.menuoff()
      });


    //   // gsap.to(menu.headerMenu, 0.2, {
    //   //   autoAlpha: 0,
    //   //   onComplete: () => {
    //   //     menu.isOpen = false;
    //   //     menu.isTransition = false;
    //   //     menu.header.removeClass(menu.active);
    //   //     menu.headerMenuInner.removeClass(menu.active);
    //   //   }
    //   // });
    });

    menu.trigger.addEventListener('click', function(){
      if (!menu.isTransition) {
        menu.isTransition = true;
        if (!menu.isOpen) {
          Global.header.classList.add(menu.active);
          gsap.to(Global.menu, 0.4, {
            delay: 0,
            autoAlpha: 1,
            onComplete: () => {
              // LogoMotion.lottieGoToAndStop(0);
              // gsap.set("main", {
              //   autoAlpha: 0
              // });
              gsap.to(".-ProdList .prod-item", 1.5,{
                ease:'Power1.easeInOut',
                opacity: 1,
                y: 0,
                stagger: 0.1,
                onComplete:()=>{
                  menu.isOpen = true;
                  menu.isTransition = false;
                }
              });
            }
          });
        } else {
          menu.menuoff()
        }
      }
    })
    // menu.trigger.on("click", () => {
    //   // console.log("trans" + menu.isTransition)
    //   // console.log("open" + menu.isOpen)
    //   if (!menu.isTransition) {
    //     menu.isTransition = true;
    //     if (!menu.isOpen) {
    //       menu.header.classList.add(menu.active);
    //       gsap.to(Global.menu, 0.4, {
    //         delay: 0,
    //         autoAlpha: 1,
    //         onComplete: () => {
    //           // LogoMotion.lottieGoToAndStop(0);
    //           // gsap.set("main", {
    //           //   autoAlpha: 0
    //           // });
    //           gsap.to(".-ProdList .prod-item", 1.5,{
    //             ease:'Power1.easeInOut',
    //             opacity: 1,
    //             y: 0,
    //             stagger: 0.1,
    //             onComplete:()=>{
    //               menu.isOpen = true;
    //               menu.isTransition = false;
    //             }
    //           });

              
    //         }
    //       });
    //     } else {
    //       // gsap.to("main", 0.4, {
    //       //   autoAlpha: 1,
    //       //   top: 0,
    //       //   onStart: () => {
    //       //     // LogoMotion.lottieGoToAndStop(50);
    //       //     // LogoMotion.lottiePlay();
    //       //   },
    //       //   onComplete: () => {
    //       //     menu.headerMenuInner.removeClass(menu.active);
    //       //     // LogoMotion.lottiePlay();
    //       //   }
    //       // });
    //       menu.menuoff()
    //     }
    //   }
    // });
  },
  menuoff:()=>{
    Global.header.classList.remove(menu.active);
    gsap.to(Global.menu, 0.2, {
      autoAlpha: 0,
      onComplete: () => {
        gsap.set(".-ProdList .prod-item",{y:20,opacity:0})
        menu.isOpen = false;
        menu.isTransition = false;
      }
    });
  }
};
